/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */
import React, { Component } from 'react';
import { TextInput } from '@pearson-components/elements-sdk/build/dist.elements-sdk';
import Select from 'react-select';
import Dropzone from 'react-dropzone';

export default class FileUploadModal extends Component {
    static get propTypes() {
        return {
        };
    }

    constructor(props) {
        super(props);
        this.state = {
            file: "",
            selectValue: {
                value: 'CustomTOCPage',
                label: 'Custom Table of Contents'
            },
            dropdownOptions: [
                { value: 'CustomTOCPage', label: 'Custom Table of Contents' },
                { value: 'CustomFrontMatter', label: 'Custom Front Matter' },
                { value: 'CustomTitlePage', label: 'Custom Title' },
                { value: 'CustomCopyrightPage', label: 'Custom Copyright' },
            ]
        };
    }

    handleSelectOnChange = (event) => {
        this.setState({
            selectValue: {
                value: event.value,
                label: event.label
            }
        });
        this.props.handleSelectOnChange(event.value);
    };

    onDrop = (files) => {
        this.setState({
            fileName: files[0].name
        });
        this.props.onDrop(files[0]);
    };

    render() {
        return (
            <div className="pe-row file-upload-container">
                <div className="file-upload-page">
                    <div className="file-upload pe-col-6">
                        <div className="child-container">
                            <label className="pe-label--bold ">File</label>
                            <TextInput id="fileName" changeHandler={() => { }}
                                placeholder="File Name" inputState="disabled" value={this.state.fileName} />
                        </div>
                        <br></br>
                        <Dropzone onDrop={(acceptedFiles) => { console.log("in side function", acceptedFiles); this.onDrop(acceptedFiles); }}>
                            {({ getRootProps, getInputProps }) => (
                                <section>
                                    <div {...getRootProps()}>
                                        <input {...getInputProps()} />
                                        <button className="pe-btn">Choose File</button>
                                        <label className="pdf-only pe-label--small"> *PDF Only</label>
                                    </div>
                                </section>
                            )}
                        </Dropzone>
                    </div>

                    <div className="file-type pe-col-8">
                        <label className="pe-label--bold">Type</label>
                        <Select
                            className="pe-selectInput--basic"
                            backspaceRemoves={false}
                            clearable={false}
                            options={this.state.dropdownOptions}
                            searchable={false}
                            value={this.state.selectValue}
                            onChange={this.handleSelectOnChange} />
                    </div>
                    {this.props.error && (
                        <div className="file-error pe-col-6">
                            <label>{this.props.errorMsg}</label>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/components/pages/BookContainer/ComponentPageComponents/FrontMatterComponent/FileUploadModal.js